import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Benchmarks } from 'modules/Benchmarks';
import { BenchmarkAssetWeighted } from 'modules/BenchmarkAssetWeighted';
import { BenchmarkStaticWeighted } from 'modules/BenchmarkStaticWeighted';
import { BenchmarkCompositeWeighted } from 'modules/BenchmarkCompositeWeighted';
import { PullForward } from './modules/PullForward';
import { BenchmarkAbsoluteReturn } from 'modules/AbsoluteReturn';
import { BenchmarkCompositeReturn } from 'modules/CompositeReturn';
import { paths } from 'routes';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import { ManageJobs } from 'modules/ManageJobs';
import { NoAccess } from 'components/403';
import { NotFound } from 'components/404';

export const RootRoutes: React.FC = () => {
  const [dataEnvironment] = useDataEnvironment();

  return (
    <>
      {dataEnvironment?.id ? (
        <Switch>
          <Route exact path='/'>
            <Redirect to={paths.benchmarks} />
          </Route>
          <Route exact path={paths.noAccess} component={NoAccess} />
          <Route exact path={paths.benchmarks} component={Benchmarks} />
          <Route
            path={`${paths.benchmarkStaticWeighted}/:typeId`}
            component={BenchmarkStaticWeighted}
          />
          <Route
            path={paths.benchmarkStaticWeighted}
            component={BenchmarkStaticWeighted}
          />

          <Route
            path={`${paths.benchmarkAssetWeighted}/:typeId`}
            component={BenchmarkAssetWeighted}
          />
          <Route
            path={paths.benchmarkAssetWeighted}
            component={BenchmarkAssetWeighted}
          />

          <Route
            path={`${paths.benchmarkCompositeWeighted}/:typeId`}
            component={BenchmarkCompositeWeighted}
          />
          <Route
            path={paths.benchmarkCompositeWeighted}
            component={BenchmarkCompositeWeighted}
          />

          <Route
            path={`${paths.pullForward}/:typeId`}
            component={PullForward}
          />
          <Route path={paths.pullForward} component={PullForward} />

          <Route
            path={`${paths.benchmarkAbsoluteReturn}/:typeId`}
            component={BenchmarkAbsoluteReturn}
          />
          <Route
            path={paths.benchmarkAbsoluteReturn}
            component={BenchmarkAbsoluteReturn}
          />

          <Route
            path={`${paths.benchmarkCompositeReturn}/:typeId`}
            component={BenchmarkCompositeReturn}
          />
          <Route
            path={paths.benchmarkCompositeReturn}
            component={BenchmarkCompositeReturn}
          />

          <Route path={paths.manageJobs} component={ManageJobs} />

          <Route path='*' component={NotFound} />
        </Switch>
      ) : null}
    </>
  );
};
